import styled from '@emotion/styled';
import React, { ChangeEvent, useMemo } from 'react';
import { COLOR_MAP } from '../../../../constants/ColorNames';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedContactDetailsType } from '../../../../redux/slice/campaignSlice';
import { Box } from '@mui/material';
import RadioButtonGroups from '../../../../common/components/RadioButtonsGroup';
import Tooltip from '../../../../common/components/Tooltip';
import { campaignMaxLimitSelector } from '../../../../redux/selectors/user.selector';





type ContactedProfileToggleProps = {
  disabled?: boolean;
  disabledMessage?: string
};

const ContactOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.2rem 0.8rem;
  gap: 1.6rem;
  background-color: ${COLOR_MAP.WHITE};
  border: 1px solid #e8e8eb;
  border-top: none;
`;

const ContactedProfileToggle = (props: ContactedProfileToggleProps) => {
  const [selectedContactType, setSelectedContactType] = React.useState('All');
  const campaignMaxLimit = useSelector(campaignMaxLimitSelector);


  const Options = useMemo(()=>[
    { label: 'Send mail to all candidates', value: 'All', infoText: `Select this option to send campaign to all candidates in the folder, max ${campaignMaxLimit} at once.` },
    { label: 'Send mail to uncontacted candidates', value: 'Non-contacted', infoText: `Select this option to send campaign to candidates in the folder who haven’t been targeted yet, max ${campaignMaxLimit} at once.` },
  ],[campaignMaxLimit]);

  const {  disabled = false, disabledMessage = '' } = props;

  const dispatch = useDispatch();

  React.useEffect(()=> {
    if(!disabled){
      setSelectedContactType('All')
    }
    else {
      setSelectedContactType('');
    }
  },[disabled])

  const handleContactTypeChange = React.useCallback(
    (event: ChangeEvent<Element>, value: string) => {
      setSelectedContactType(value);
      dispatch(setSelectedContactDetailsType({ selectedContactType: value }));
    },
    [dispatch]
  );

  return (
    <Tooltip
    title={disabledMessage}
    disabled={!disabled}
    >
    <Box sx={{ width: '100%' }}>
      <ContactOptionsWrapper>
        <RadioButtonGroups
          disabled={disabled}
          direction={'column'}
          onChange={handleContactTypeChange}
          value={selectedContactType}
          gap={'1.6rem'}
          options={Options}
        />
      </ContactOptionsWrapper>
    </Box>
    </Tooltip>
  );
};

export default ContactedProfileToggle;